import React, { useState } from 'react';
import styles from '../../css/NavBar.module.css';
import { Link, useLocation } from 'react-router-dom';

function NavBar() {
	const location = useLocation();

	const data = [
		{ id: 0, title: 'Home', navi: '/computer-coaching-center-in-nelamangala' },
		{ id: 1, title: 'Services', navi: '/Service' },
		{ id: 2, title: 'Course', navi: '/Course' },
		{ id: 3, title: 'About', navi: '/About' },
		{ id: 4, title: 'Contact', navi: '/Contact' },
		{ id: 5, title: '8884264377', navi: 'tel:+91 8884264377' },
	];

	return (
		<div>
			<div className={styles.linear} />

			<div className={styles.logo_container}>
				<Link to="/computer-coaching-center-in-nelamangala">
					<img
						src={require('../images/logo.png')}
						alt=""
						className={styles.navimage}
					/>
				</Link>
				<p className={styles.title}>ಕನಸು ಶೈಕ್ಷಣಿಕ ಮತ್ತು ಚಾರಿಟೇಬಲ್ ಟ್ರಸ್ಟ್</p>
				<p className={styles.title}>KANASU EDUCATIONAL AND CHARITABLE TRUST</p>
				<p className={styles.title}>कनासु शैक्षिक और धर्मार्थ ट्रस्ट</p>
			</div>

			<div className={styles.btn_group}>
				{data.map((item) => {
					const isCurrentPage = item.navi === location.pathname;
					const titleStyle = isCurrentPage
						? { color: '#e05710' }
						: { color: 'black' };

					return (
						<Link
							className={styles.btn}
							style={titleStyle}
							key={item.id}
							to={item.navi}
						>
							{item.title}
						</Link>
					);
				})}
			</div>

			<div className={styles.mob_view}>
				<Link to="/computer-coaching-center-in-nelamangala">
					<img
						src={require('../images/logo.png')}
						alt=""
						className={styles.navimage}
					/>
				</Link>
				<p className={styles.title}>KANASU EDUCATIONAL AND CHARITABLE TRUST</p>
			</div>
		</div>
	);
}

export default NavBar;
